import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { GoalCategoriesFormValues } from 'src/models/GoalCategories.model';
import GoalCategoriesForm from '../Layout/GoalCategoriesForm';
import { useEditGoalCategoryiesMutation, useGetGoalCategoryByIdQuery } from 'src/services/GoalCategoryServices';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';

type Props = {
  onClose: () => void;
  goalId?: string
};

const EditGoalCategoriesFormWrapper = ({ onClose, goalId }: Props) => {
  const [editGoalCategory] = useEditGoalCategoryiesMutation()

  const [goalCateGoryData, setGoalCategoryData] = useState<any>({})

  const { data, isLoading, isFetching } = useGetGoalCategoryByIdQuery(goalId)
  useEffect(() => {
    if (!isLoading && !isFetching) {
      setGoalCategoryData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: GoalCategoriesFormValues = {
    categoryName: goalCateGoryData?.categoryName || '-',
  };

  // Validation Schema
  const validationSchema = object().shape({
    categoryName: string().required('Please enter category name'),
  });

  // Handle Submit
  const handleSubmit = (
    values: GoalCategoriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<GoalCategoriesFormValues>
  ) => {

    editGoalCategory({
      body: values,
      goalId: goalId
    }).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setSubmitting(false);
    })
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}

            <GoalCategoriesForm formikProps={formikProps} onClose={onClose} formType={'Edit'} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditGoalCategoriesFormWrapper;